"use client";

import { useCallback } from "react";

import type { CookieJarKey, CookieJarValue } from "./cookie-jar-configs";
import { useCookieJar } from "./cookie-jar-provider";

export { getCookieClient, setCookieClient } from "./cookie-client";

export function useCookieState<K extends CookieJarKey>(
  name: K,
): [CookieJarValue<K>, (value: CookieJarValue<K>) => void] {
  const { values, setValue: jarSetValue } = useCookieJar();
  const value = values[name];

  const setValue = useCallback(
    (next: CookieJarValue<K>) => {
      jarSetValue(name, next);
    },
    [jarSetValue, name],
  );

  return [value, setValue];
}
